import customAxios from "../../customAxios";
import { FIND_AREA } from "../../routes";
// import {ADMIN_ALL_SERVICE} from "../../routes";

type Props = {
  page?: string | number;
  limit?: string | number;
  company?: string;
};

const findArea = async (props: Props) => {
  console.log(props);

  var thisUrl = FIND_AREA + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}&`;
  if (props.company) thisUrl += `company=${props.company}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ FIND_AREA: error });
  }
};

export default findArea;
